import React, { memo } from "react";
import styled from "styled-components";
import { MaterialIcon, PrimaryButton, ButtonSizeOptions, ModuleBase } from "@loanbossinc/component-library";

const StyledCard = styled(ModuleBase)`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 24px;
    margin-bottom: 24px;
    margin-top: 0 !important;

    .material-icons {
      color: #C4C4C4;
      font-size: xxx-large;
    }

    .svg {
      filter: invert(99%) sepia(0%) saturate(477%) hue-rotate(170deg) brightness(83%) contrast(84%);
    }

    .title-wrapper {
      display: flex;
      flex-direction: column;
      flex: 1;
      font-family: Work Sans;
      font-style: normal;
      font-weight: normal;
      color: #000000;
      margin-left: 18px;

      .title {
        font-weight: 500;
        font-size: 16px;
      }

      .subtitle {
        font-size: 14px;
      }
    }
  }
`;

const WhatIfModule = ({
  title = "",
  subtitle = "",
  onClick = () => console.log("What If Module Clicked"),
  iconName,
  icon,
  disabled = false
}) => (
  <StyledCard elevation={0}>
    {iconName ? <MaterialIcon iconName={iconName} /> : icon()}
    <div className="title-wrapper">
      <span className="title">{title}</span>
      <span className="subtitle">{subtitle}</span>
    </div>
    <PrimaryButton
      disabled={disabled}
      label="Launch"
      size={ButtonSizeOptions.sm}
      onClick={onClick}
    />
  </StyledCard>
);

export default memo(WhatIfModule);
